import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { createMember } from "../../actions/memberActions";
import { getInstitutions } from "../../actions/institutionActions";
import { getBranches } from "../../actions/branchActions";
import { getGrades } from "../../actions/gradeActions";
import { getSites } from "../../actions/siteActions";
import Select from "react-select";


import classnames from "classnames";

class NewMember extends Component {
  constructor() {
    super();
    this.state = {
      firstname: "",
      surname: "",
      nationalId: "",
      gender: "",
      maritalStatus: "",
      dob: "",
      cellNumber: "",
      email: "",
      town: "",
      nextOfKin: "",
      nokPhone: "",
      relationship: "",
      grade: "",
      basicWage: "",
      jobTitle: "",
      currentBranch: "",
      status: "",
      //stoporder details
      stoporders: [],
      stoporder: {},
      stopOrderNumber: "",
      dateEmployed: "",
      dateJoined: "",
      recruitmentBranch: "",
      site:"",
      institution: "",
      errors: {},
    };
    this.saveMember = this.saveMember.bind(this);
    this.cancel = this.cancel.bind(this);
    this.handleGradeChange = this.handleGradeChange.bind(this);
    this.handleCurrentBranchChange = this.handleCurrentBranchChange.bind(this);
    this.handleRecruitmentBranchChange = this.handleRecruitmentBranchChange.bind(this);
    this.handleInstitutionChange = this.handleInstitutionChange.bind(this);
    this.handleSiteChange = this.handleSiteChange.bind(this);
  }

  componentDidMount() {
    this.props.getBranches();
    this.props.getGrades();
    this.props.getInstitutions();
    this.props.getSites();
  }
  //life cycle hooks
  componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      this.setState({ errors: nextProps.errors });
    }
    this.state.errors.data && alert(this.state.errors.data.message)
  }

  onChange = (e) => this.setState({ [e.target.name]: e.target.value });


  handleGradeChange(val) {
    this.setState({ grade: val });
  }
  handleCurrentBranchChange(val) {

    this.setState({ currentBranch: val });
  }
  handleRecruitmentBranchChange(val) {

    this.setState({ recruitmentBranch: val });
  }
  handleInstitutionChange(val) {
    this.setState({ institution: val });
  }
  handleSiteChange(val) {
    this.setState({ site: val });
  }
  
  saveMember = (e) => {
    e.preventDefault();

    if (!this.state.recruitmentBranch) {
      alert("Recruitment branch is required")
    } else if (!this.state.institution) {
      alert("Institution is required")
    } else if (!this.state.currentBranch) {
      alert("Current branch is required")
    } else if (!this.state.grade) {
      alert("Grade is required")
    } else {
      //construct stoporder object
      let tempSO = {
        stopOrderNumber: this.state.stopOrderNumber,
        dateEmployed: this.state.dateEmployed,
        dateJoined: this.state.dateJoined,
        recruitmentBranch: this.state.recruitmentBranch,
        institution: this.state.institution,
        site:this.state.site
      }
      this.setState({ stoporders: [] })
      this.state.stoporders.push(tempSO);


      let member = {
        firstname: this.state.firstname,
        surname: this.state.surname,
        nationalId: this.state.nationalId,
        gender: this.state.gender,
        maritalStatus: this.state.maritalStatus,
        dob: this.state.dob,
        cellNumber: this.state.cellNumber,
        email: this.state.email,
        town: this.state.town,
        nextOfKin: this.state.nextOfKin,
        nokPhone: this.state.nokPhone,
        relationship: this.state.relationship,
        grade: this.state.grade,
        basicWage: this.state.basicWage,
        jobTitle: this.state.jobTitle,
        currentBranch: this.state.currentBranch,
        status: this.state.status,
        stoporders: this.state.stoporders,
      };

      this.props.createMember(member, this.props.history);
    }
  };

  cancel() {
    this.props.history.push("/member-list");
  }

  render() {
    const { errors } = this.state;

    const { grades } = this.props.grade;
    const { branches } = this.props.branch;
    const { institutions } = this.props.institution;
    const { sites } = this.props.site;
    return (
      <div className="container">
        <div className="card m-auto  border-primary shadow-lg rounded p-3">
          <h5 className="display-4 text-center">Member Registration</h5>
          <p className="lead text-center">New Member Details</p>
          <hr />
          {(errors.data || errors.status) && (<div className="alert alert-danger text-center" role="alert">
            {errors.data.message || "Your request could not be processed, please check your data"}
          </div>)}
          <h5 className="display-5 text-center  bg-info">
            Personal Details
            </h5>
       
        <form onSubmit={this.saveMember}>
          <div className="row m-3">

            <div className="form-group col-sm-4 m-auto">
              <label>Firstname**</label>
              <input
                className={classnames("form-control", {
                  "is-invalid": errors.firstname,
                })}
                type="text"
                name="firstname"
                required
                id="firstname"
                value={this.state.firstname}
                onChange={this.onChange}
                placeholder="Firstname"
              />
              {errors.firstname && (
                <div className="invalid-feedback">{errors.firstname}</div>
              )}
            </div>

            <div className="form-group col-sm-4 m-auto">
              <label>Surname**</label>
              <input
                className={classnames("form-control", {
                  "is-invalid": errors.surname,
                })}
                type="text"
                name="surname"
                id="surname"
                required
                value={this.state.surname}
                onChange={this.onChange}
                placeholder="Surname"
              />
              {errors.surname && (
                <div className="invalid-feedback">{errors.surname}</div>
              )}
            </div>

            <div className="form-group col-sm-4 m-auto">
              <label>National Id**</label>
              <input
                className={classnames("form-control", {
                  "is-invalid": errors.nationalId,
                })}
                type="text"
                name="nationalId"
                required
                id="nationalId"
                value={this.state.nationalId}
                onChange={this.onChange}
                placeholder="National Id"
              />
              {errors.nationalId && (
                <div className="invalid-feedback">{errors.nationalId}</div>
              )}
            </div>

            <div className="form-group col-sm-4 m-auto">
              <label>Gender**</label>
              <select
                className="form-control"
                value={this.state.gender}
                onChange={this.onChange}
                required={true}
                name="gender"
              >
                <option value={null}></option>
                <option value={"M"}>M</option>
                <option value={"F"}>F</option>
              </select>
            </div>

            <div className="form-group col-sm-4 m-auto">
              <label>Marital Status</label>
              <select
                className="form-control"
                onChange={this.onChange}
                value={this.state.maritalStatus}
                name="maritalStatus"
              >
                <option value={null}></option>
                <option value="Single">Single</option>
                <option value="Married">Married</option>
                <option value="Divorced">Divorced</option>
                <option value="Widowed">Widowed</option>
              </select>
            </div>

            <div className="form-group col-sm-4 m-auto">
              <label>Date Of Birth</label>
              <input
                type="date"
                className="form-control form-control-lg"
                name="dob"
                onChange={this.onChange}
                value={this.state.dob || ""}
              />
            </div>

            <div className="form-group col-sm-4 m-auto">
              <label>Mobile Number</label>
              <input
                className={classnames("form-control", {
                  "is-invalid": errors.cellNumber,
                })}
                type="text"
                name="cellNumber"
                id="cellNumber"
                value={this.state.cellNumber}
                onChange={this.onChange}
                placeholder="Mobile Number"
              />
              {errors.cellNumber && (
                <div className="invalid-feedback">{errors.cellNumber}</div>
              )}
            </div>

            <div className="form-group col-sm-4 m-auto">
              <label>Email</label>
              <input
                className={classnames("form-control", {
                  "is-invalid": errors.email,
                })}
                type="text"
                name="email"
                id="email"
                value={this.state.email}
                onChange={this.onChange}
                placeholder="Email"
              />
              {errors.email && (
                <div className="invalid-feedback">{errors.email}</div>
              )}
            </div>

            <div className="form-group col-sm-4 m-auto">
              <label>Town</label>
              <input
                className={classnames("form-control", {
                  "is-invalid": errors.town,
                })}
                type="text"
                name="town"
                id="town"
                value={this.state.town}
                onChange={this.onChange}
                placeholder="Town"
              />
              {errors.town && (
                <div className="invalid-feedback">{errors.town}</div>
              )}
            </div>        

         
            <div className="form-group col-sm-12 m-auto">
              <label>Current Branch**</label>
              <Select
                className="react-selectcomponent"
                classNamePrefix="name-select"
                onChange={this.handleCurrentBranchChange}
                getOptionLabel={(branch) => `${branch.branchName}`}
                isOptionSelected={true}
                getOptionValue={(branch) => `${branch}`}
                required="true"
                options={branches}
              />
            </div>
          </div>
          <hr />
          <h5 className="display-5 text-center  bg-info">
            Next Of Kin Details
            </h5>
          <div className="row m-3">
            <div className="form-group col-sm-4 m-auto">
              <label>Next Of Kin</label>
              <input
                className={classnames("form-control", {
                  "is-invalid": errors.nextOfKin,
                })}
                type="text"
                name="nextOfKin"
                id="nextOfKin"
                value={this.state.nextOfKin}
                onChange={this.onChange}
                placeholder="Next Of Kin"
              />
              {errors.nextOfKin && (
                <div className="invalid-feedback">{errors.nextOfKin}</div>
              )}
            </div>

            <div className="form-group col-sm-4 m-auto">
              <label>Next Of Kin Phone</label>
              <input
                className={classnames("form-control", {
                  "is-invalid": errors.nokPhone,
                })}
                type="text"
                name="nokPhone"
                id="nokPhone"
                value={this.state.nokPhone}
                onChange={this.onChange}
                placeholder="Next Of Kin Phone"
              />
              {errors.nokPhone && (
                <div className="invalid-feedback">{errors.nokPhone}</div>
              )}
            </div>

            <div className="form-group col-sm-4 m-auto">
              <label>Relationship</label>
              <select
                className="form-control"
                onChange={this.onChange}
                value={this.state.relationship}
                name="relationship"
              >
                <option value={null}></option>
                <option value="Spouse">Spouse</option>
                <option value="Father">Father</option>
                <option value="Mother">Mother</option>
                <option value="Sister">Sister</option>
                <option value="Son">Son</option>
                <option value="Daughter">Daughter</option>
                <option value="Brother">Brother</option>
                <option value="Cousin">Cousin</option>
                <option value="Aunt">Aunt</option>
                <option value="Uncle">Uncle</option>
                <option value="Brother">Brother</option>
                <option value="Sister">Sister</option>
                <option value="Friend">Friend</option>
                <option value="Pastor">Pastor</option>
              </select>
            </div>
          </div>


          <hr />
          <h5 className="display-5 text-center bg-info">
            Employment Details
            </h5>
          <div className="row m-3">
            <div className="form-group col-sm-4 m-auto">
              <label>Stop Order Number</label>
              <input
                className={classnames("form-control", {
                  "is-invalid": errors.stopOrderNumber,
                })}
                type="number"
                name="stopOrderNumber"
                id="stopOrderNumber"
                value={this.state.stopOrderNumber}
                onChange={this.onChange}
                placeholder="Stop Order Number"
                required={true}
              />
              {errors.stopOrderNumber && (
                <div className="invalid-feedback">
                  {errors.stopOrderNumber}
                </div>
              )}
            </div>
            <div className="form-group col-sm-4 m-auto">
              <label>Grade</label>
              <Select
                className="react-selectcomponent"
                classNamePrefix="name-select"
                onChange={this.handleGradeChange}
                getOptionLabel={(grade) => `${grade.gradeName}`}
                isOptionSelected={true}
                value={this.state.grade}
                options={grades}
                required={true}
              />
            </div>


            <div className="form-group col-sm-4 m-auto">
              <label>Occupation</label>
              <input
                className={classnames("form-control", {
                  "is-invalid": errors.jobTitle,
                })}
                type="text"
                name="jobTitle"
                id="jobTitle"
                value={this.state.jobTitle}
                onChange={this.onChange}
                placeholder="Occupation"
                required={true}
              />
              {errors.jobTitle && (
                <div className="invalid-feedback">{errors.jobTitle}</div>
              )}
            </div>
            <div className="form-group col-sm-4 m-auto">
              <label>Date Of Employment</label>
              <input
                type="date"
                className="form-control form-control-lg"
                name="dateEmployed"
                onChange={this.onChange}
                value={this.state.dateEmployed || ""}
                required={true}
              />
            </div>

            <div className="form-group col-sm-4 m-auto">
              <label>Joining Date</label>
              <input
                type="date"
                className="form-control form-control-lg"
                name="dateJoined"
                onChange={this.onChange}
                value={this.state.dateJoined || ""}
                required={true}
              />
            </div>


            <div className="form-group col-sm-4">
              <label>Recruitment Branch</label>
              <Select
                className="react-selectcomponent"
                classNamePrefix="name-select"
                onChange={this.handleRecruitmentBranchChange}
                getOptionLabel={(branch) => `${branch.branchName}`}
                isOptionSelected={true}
                value={this.state.branch}
                options={branches}
                required={true}
              />
            </div>
            <div className="form-group col-sm-4">
              <label>Site</label>
              <Select
                className="react-selectcomponent"
                classNamePrefix="name-select"
                onChange={this.handleSiteChange}
                getOptionLabel={(site) => `${site.siteName}`}
                isOptionSelected={true}
                value={this.state.site}
                options={sites}
                required={true}
              />
            </div>

            <div className="form-group col-sm-4 ">
              <label>Institution</label>
              <Select
                className="react-selectcomponent"
                classNamePrefix="name-select"
                onChange={this.handleInstitutionChange}
                getOptionLabel={(institution) =>
                  `${institution.institutionName}`
                }
                isOptionSelected={true}
                value={this.state.institution}
                options={institutions}
                isRequired={true}
              />
            </div>
          </div>

          <div className="row m-3">
            <div className="form-group col-sm-6">
              <button
                type="submit"
                className="btn btn-primary btn-block mt-4"
              >
                Save
                  </button>
            </div>

            <div className="form-group col-sm-6">
              <button
                type="button"
                className="btn btn-secondary btn-block mt-4"
                onClick={this.cancel}
              >
                Cancel
                  </button>
            </div>
          </div>
        </form>
      </div>
      </div>
    );
  }
}

NewMember.propTypes = {
  createMember: PropTypes.func.isRequired,
  getGrades: PropTypes.func.isRequired,
  getBranches: PropTypes.func.isRequired,
  getSites: PropTypes.func.isRequired,
  getInstitutions: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  grade: state.grade,
  branch: state.branch,
  institution: state.institution,
  site: state.site,
  errors: state.errors,
});

export default connect(mapStateToProps, {
  createMember,
  getGrades,
  getBranches,
  getSites,
  getInstitutions,
})(NewMember);
